// extracted by mini-css-extract-plugin
export default {"news-feed-admin-right-side":"NewsFeedAdminRightSide_news-feed-admin-right-side__F3ceR"};